export default {
      id: "close-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#close",
      toString: function () {
        return this.url;
      }
    }